import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';

import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';
import { IDropDown } from '../company-view-detail/models/IDropDown';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  public tipoList: IDropDown<string>[]
  public sectorList: IDropDown<string>[]
  public tipoFormato: IDropDown<string>[]
  public contingenciasComunesList: IDropDown<string>[]
  public prorrogaContratoList: IDropDown<string>[]
  public periodicidadList: IDropDown<string>[]
  public fechaDePagoList: IDropDown<number>[]
  public grupoEmpresaList: any[]
  public tipoDiagnosticoList: IDropDown<string>[]
  public bajaNuevaList: IDropDown<string>[]
  public fAntiguedadList: IDropDown<string>[]
  public tarifaIndisposicionList: IDropDown<number>[]
  public leaveTypeList: IDropDown<string>[]
  public cnaeList: IDropDown<string>[];

  constructor(private _apiService: ApiService) {

  }

  GetAllDropDownData(): Observable<RestResponse> {
    const url = `${API.CompanyManagement.getAllDropDownData}`;
    return this._apiService.get(url);
  }

  LoadCnae(sector: string): Observable<RestResponse> {
    let url = `${API.CompanyManagement.loadCnaeList}`;
    url = url.replace('{sector}', sector);
    return this._apiService.get(url); 
  }

  GetConvenioList(): Observable<RestResponse> {
    const url = `${API.CompanyManagement.getConvenio}`;
    return this._apiService.get(url);
  }
 
  GetParentControls(companyId): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getParentControls}`;
    url = url.replace('{companyId}', companyId);
    return this._apiService.get(url);
  }
 
  GetEmpresaById(companyId: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getEmpresaById}`;
    url = url.replace('{companyId}', companyId);
    return this._apiService.get(url);
  }
 
  GetGrupoEmpresa(companyId,): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getGrupoEmpresa}`;
    url = url.replace('{companyId}', companyId);
    return this._apiService.get(url);
  }

  AddAdjuntos(adjunto): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addAdjuntos}`;
    return this._apiService.post(url, adjunto);
  }

  UpdateEmpresa(empresaModel: any): Observable<RestResponse> {
    const url = `${API.CompanyManagement.updateEmpresa}`;
    return this._apiService.put(url, empresaModel);
  }

  DeleteAdjuntos(padreId: any, companyId: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteAdjuntos}`;
    url = url.replace('{padreId}', padreId);
    url = url.replace('{companyId}', companyId);
    return this._apiService.delete(url);
  }
  closingStaff(companyId: any,finGestion: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.closingStaff}`;
    url = url.replace('{companyId}', companyId);
    url = url.replace('{finGestion}', finGestion);
    return this._apiService.get(url);
  }

  LoadSectorList() {
    this.GetAllDropDownData().subscribe(res => {
      if (res?.result?.sector) {
        this.sectorList = res.result.sector.map(s => ({
          viewValue: s.viewValue,
          value: s.value,
          stringValue: s.stringValue
        }));
      }
    }, error => {
      console.error("Error cargando sectores:", error);
    });
  }
  
  StaticDropDownList(){
    this.tipoList = [
      { viewValue: 'Grupo de Empresas', value: 'GRUPO' },
      { viewValue: 'Empresa', value: 'EMPRESA' },
      { viewValue: 'Area / Departamento', value: 'AREA' },
      { viewValue: 'Mutua', value: 'MUTUA' },
    ];
    /*this.sectorList = [
      { viewValue: 'AGRICULTURA', value: 'AGRICULTURA' },
      { viewValue: 'ALIMENTACION', value: 'ALIMENTACION' },
      { viewValue: 'ARTES GRAFICAS', value: 'ARTES GRAFICAS' },
      { viewValue: 'AUTOMOCION', value: 'AUTOMOCION' },
      { viewValue: 'CAZA Y PESCA', value: 'CAZA Y PESCA' },
      { viewValue: 'COMUNICACIONES', value: 'COMUNICACIONES' },
      { viewValue: 'CONSTRUCCION', value: 'CONSTRUCCION' },
      { viewValue: 'CUERO', value: 'CUERO' },
      { viewValue: 'DISTRIBUCION', value: 'DISTRIBUCION' },
      { viewValue: 'ELECTRONICA', value: 'ELECTRONICA' },
      { viewValue: 'ENERGIA', value: 'ENERGIA' },
      { viewValue: 'Mutua', value: 'MUTUA' },
      { viewValue: 'FABRICANTES DIVERSOS', value: 'FABRICANTES DIVERSOS' },
      { viewValue: 'FARMACEUTICA', value: 'FARMACEUTICA' },
      { viewValue: 'FINANZAS', value: 'FINANZAS' },
      { viewValue: 'GANADERIA', value: 'GANADERIA' },
      { viewValue: 'HOSTELERIA', value: 'HOSTELERIA' },
      { viewValue: 'MADERA', value: 'MADERA' },
      { viewValue: 'MAQUINARIA', value: 'MAQUINARIA' },
      { viewValue: 'MAYORISTA', value: 'MAYORISTA' },
      { viewValue: 'METALURGIA', value: 'METALURGIA' },
      { viewValue: 'MINERIA', value: 'MINERIA' },
      { viewValue: 'ORGANISMOS PUBLICOS', value: 'ORGANISMOS PUBLICOS' },
      { viewValue: 'PAPEL', value: 'PAPEL' },
      { viewValue: 'PIEDRA, ARCILLA, VIDRIO Y HORMIGON', value: 'PIEDRA, ARCILLA, VIDRIO Y HORMIGON' },
      { viewValue: 'QUIMICA', value: 'QUIMICA' },
      { viewValue: 'SEGURIDAD', value: 'SEGURIDAD' },
      { viewValue: 'SEGUROS', value: 'SEGUROS' },
      { viewValue: 'SERVICIOS DE LIMPIEZA', value: 'SERVICIOS DE LIMPIEZA' },
      { viewValue: 'SERVICIO PUBLICO', value: 'SERVICIO PUBLICO' },
      { viewValue: 'SERVICIOS DE OCIO', value: 'SERVICIOS DE OCIO' },
      { viewValue: 'SERVICIOS INDUSTRIALES', value: 'SERVICIOS INDUSTRIALES' },
      { viewValue: 'SERVICIOS SANITARIOS', value: 'SERVICIOS SANITARIOS' },
      { viewValue: 'SERVICIOS COMERCIALES', value: 'SERVICIOS COMERCIALES' },
      { viewValue: 'SIDERURGIA', value: 'SIDERURGIA' },
      { viewValue: 'TABACO', value: 'TABACO' },
      { viewValue: 'TRANSPORTES', value: 'TRANSPORTES' },
      { viewValue: 'VARIOS', value: 'VARIOS' }
    ];*/
    this.contingenciasComunesList = [
      { viewValue: 'Mutua', value: 'MUTUA' },
      { viewValue: 'Seguridad Social', value: 'SS' },
      { viewValue: 'Autoasegurador', value: 'AUTOASEGURADOR' },
    ];
    this.prorrogaContratoList = [
      { viewValue: 'Tácita', value: 'Tacita' },
      { viewValue: 'Expresa', value: 'Expresa' }
    ];
    this.periodicidadList = [
      { viewValue: 'MENSUAL', value: 'MENSUAL' },
      { viewValue: 'BIMENSUAL', value: 'BIMENSUAL' },
      { viewValue: 'TRIMESTRAL', value: 'TRIMESTRAL' },
      { viewValue: 'SEMESTRAL', value: 'SEMESTRAL' },
      { viewValue: 'ANNUAL', value: 'ANNUAL' }
    ];
    this.fechaDePagoList = [
      { viewValue: '0', value: 0 },
      { viewValue: '30', value: 30 },
      { viewValue: ' 60', value: 60 },
      { viewValue: '90', value: 90 }
    ];
    this.tipoDiagnosticoList = [
      { viewValue: 'CIE9', value: 'CIE9' },
      { viewValue: 'CIE10', value: 'CIE10' }
    ];
    this.bajaNuevaList = [
      { viewValue: 'Contacto telefónico', value: 'CONTACTO' },
      { viewValue: 'Visita', value: 'DOMICILIO' },
      { viewValue: 'Contacto administrativo', value: 'ADMIN' }
    ];
    this.fAntiguedadList = [
      { viewValue: 'No', value: 'N' },
      { viewValue: 'Sí', value: 'S' },
      { viewValue: 'Obligatoria', value: 'O' }
    ];
    this.tarifaIndisposicionList = [
      { viewValue: '1', value: 1 },
      { viewValue: '2', value: 2 },
      { viewValue: '3', value: 3 }
    ];
    this.tipoFormato = [
      { viewValue: 'WORD', value: 'WORD' },
      { viewValue: 'EXCEL', value: 'EXCEL' },
    ];
    this.leaveTypeList = [
      { viewValue: 'Accidente laboral', value: 'A' },
      { viewValue: 'Accidente no laboral', value: 'N' },
      { viewValue: 'Accidente sin baja', value: 'S' },
      { viewValue: 'Asistencial ', value: 'T' },
      { viewValue: 'Enfermedad ', value: 'E' },
      { viewValue: 'Enfermedad profesional', value: 'F' },
      { viewValue: 'Horas sindicales', value: 'H' },
      { viewValue: 'Incapacidad ', value: 'X' },
      { viewValue: 'Indisposición ', value: 'I' },
      { viewValue: 'Maternidad ', value: 'M' },
      { viewValue: 'Permiso ', value: 'P' },
      { viewValue: 'Permiso no retribuido', value: 'U' },
      { viewValue: 'Permiso retribuido', value: 'B' },
      { viewValue: 'Riesgo por embarazo', value: 'R' },

    ];
  }

  UpdateEmpresaProtocolo(empresa:any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateEmpresaProtocolo}`;
    return this._apiService.put(url,empresa);
  }


}
